export class LFDynamicWidgetConfig {
    public name: string;
    public id: string;
    public widgetType: string;
    public isOpen: boolean = false;
    public activeIndex: number;
    public columnGroup: string;
    public propertyList: any;
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/lf-dynamic-widget-config.ts